
import Vue, { PropType } from 'vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default Vue.extend({
  mixins: [staticBlockMixin],
  props: {
    isActive: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    isSingle: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      isActiveLocal: false
    }
  },
  methods: {
    toggleActive () {
      if (!this.isSingle) { return this.$emit('click') }
      this.isActiveLocal = !this.isActiveLocal
    }
  }
})
